export const CREATE_INGREDIENT56227 = "CREATE_INGREDIENT56227";
export const UPDATE_INGREDIENT56227 = "UPDATE_INGREDIENT56227";
export const DELETE_INGREDIENT56227 = "DELETE_INGREDIENT56227";
export const FETCH_INGREDIENT56227 = "FETCH_INGREDIENT56227";
export const LISTEN_TO_SELECTED_INGREDIENT56227 =
  "LISTEN_TO_SELECTED_INGREDIENT56227";
export const FILTER_INGREDIENT56227 = "FILTER_INGREDIENT56227";
